<div class="content">
  <h4>{{ "employee.config.config" | translate }}</h4>
  <div class="provider-container">
    <h5>Trainline</h5>
    <button (click)="updateTrainlineStaticData()">{{ "employee.config.update-static-data" | translate }}</button>
  </div>
</div>
